<template>
  <!-- 視力・聴力の所見有無を返す -->
  <div class="value-font">
    <div v-text="answer" :data-test="dataTest" />
  </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
  props: {
    value: {
      type: Number
    },
    dataTest: String
  },
  computed: {
    answer: function() {
      switch (this.value) {
        case 1:
          return this.$i18n.t("yourPhysicalInformation.NoInput");
        case 2:
          return this.$i18n.t("yourPhysicalInformation.NothingParticular");
        case 3:
          return this.$i18n.t("yourPhysicalInformation.AbnormalFinding");
      }
    }
  }
};
</script>

<style scoped>
.value-font {
  font-weight: bold;
}
</style>
